import { ContactFormItem } from 'app/modules/contact-form/types';

import makeApi from './api';
import { ChatItemForm } from './chatBot';

export default async function fetchContactForm(uuid: string, contactFormSlug?: string) {
  const api = makeApi();

  const queryParameters = contactFormSlug ? `?ref_slug=${contactFormSlug}` : '';
  const response = await api.post(`/api/v1/web_chat/v3.0/help-center/${uuid}/contact-forms/${queryParameters}`);

  return response.data;
}

type FormItem = {
  form_ref_id: string;
  item_ref_id: string;
  value: string | string[] | boolean;
};

export type FormSubmitPayload = FormItem[];
type Response = { chat_items: ContactFormItem[]; forms: ChatItemForm[] };

export async function submitContactForm(uuid: string, payload: FormSubmitPayload, contactFormSlug?: string) {
  const api = makeApi();
  const queryParameters = contactFormSlug ? `?ref_slug=${contactFormSlug}` : '';
  const response = await api.post<Response>(
    `/api/v1/web_chat/v3.0/help-center/${uuid}/contact-forms/submit/${queryParameters}`,
    payload
  );

  return response.data;
}
